import { CSSProperties } from "react";
import { HeaderWidgetProps } from "../models/PropsInterface";
import ColorsUtils from "../utils/ColorsUtils";

const HeaderWidget = (props: HeaderWidgetProps) => {
  const headerWidgetBackgroundColor = ColorsUtils.convertHexToRgb(
    props.header_widget.background_color
  );

  const backgroundTextStyle = {
    backgroundColor: `${
      headerWidgetBackgroundColor
        ? `rgb(${headerWidgetBackgroundColor.r},${headerWidgetBackgroundColor.g},${headerWidgetBackgroundColor.b}, ${headerWidgetBackgroundColor.a})`
        : ""
    }`,
    color: props.header_widget.text_color,
  } as CSSProperties;

  return (
    <>
      <div style={backgroundTextStyle} className={"header_widget-container"}>
        {`${props.header_widget.text}`}
      </div>
      {props.header_widget.sub_text && (
        <div style={{ color: props.header_widget.sub_text_color }}>
          {`${props.header_widget.sub_text}`}
        </div>
      )}
    </>
  );
};

export default HeaderWidget;
